const dirname = (path) => {
    if (!path) {
        throw "EMPTY PATH";
    }
    return /^(.+?)\/[^/]+$/.exec(path)?.[1] ?? "";
};

export const Path = {
    resolve: (path1, path2) => {
        while (path2.startsWith("../")) {
            path1 = dirname(path1);
            path2 = path2.substring("../".length);
        }
        return (path1 && path1 + "/") + path2;
    },
    dirname,
    basename: (path) => /[^/]+$/.exec(path)[0],
    extname: (path) => /\.\w+$/.exec(path)[0],
};
